import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";

const trimIsoDate = value => {
  if (!value) return "";
  return typeof value === "string" ? value.split("T")[0] : value;
};

const FormikDateField = ({ name, label, disabled, ...rest }) => {
  const [field] = useField(name);
  return (
    <span>
      <label>
        {label}
        <input
          {...rest}
          type="date"
          name={field.name}
          value={trimIsoDate(field.value)}
          onChange={field.onChange}
          onBlur={field.onBlur}
          disabled={disabled}
        />
      </label>
    </span>
  );
};

FormikDateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool
};

export default FormikDateField;
